import { z } from 'zod'

import { paginacaoSearchFields, toLimitOffset } from '@/widgets/data-table/table-search'

import type { StakeholderKind, StakeholderListParams } from './api'

/**
 * Search params da tela de Contatos (as 4 abas compartilham este schema — o
 * `kind` vem do slug da rota, não da query string).
 */
export const contatosSearchSchema = z.object({
  ...paginacaoSearchFields,
  q: z.string().min(1).optional(),
  documento: z.string().min(1).optional(),
  ordenar: z.enum(['name', '-name', 'created_at', '-created_at', 'kind', '-kind']).default('name'),
})

export type ContatosSearch = z.infer<typeof contatosSearchSchema>

/** Ordem default do endpoint (stakeholder_service._ORDER_BY_DEFAULT). */
export const CONTATOS_ORDEM_DEFAULT = 'name' satisfies ContatosSearch['ordenar']

/** Chaves de filtro — o que "limpar filtros" zera. */
export const CONTATOS_FILTROS = [
  'q',
  'documento',
] as const satisfies readonly (keyof ContatosSearch)[]

export function toStakeholderListParams(
  s: ContatosSearch,
  kind: StakeholderKind,
): StakeholderListParams {
  return {
    kind,
    ...(s.q !== undefined && { search: s.q }),
    ...(s.documento !== undefined && { document: s.documento }),
    order_by: s.ordenar,
    ...toLimitOffset(s),
  }
}
